import {
    n2br
} from "./main";
import {
    escapeHtml
} from "./dom";

let out = {
    // <img data-code="Some_Code">
    IMG_EMOJI_REG_EXP: /<img[^>]*data-code=["'](\w+)["'][^>]*>/gi,
    EMOJI_LIST: [
        { code: "Slightly_Smiling_Face_Emoji_Icon", url: "/img/emoji/Slightly_Smiling_Face_Emoji_Icon_42x42.png" },
        { code: "Upside_Down_Face_Emoji_Icon", url: "/img/emoji/Upside_Down_Face_Emoji_Icon_42x42.png" },
        { code: "Smiling_Face_Emoji_Icon", url: "/img/emoji/Smiling_Face_Emoji_Icon_42x42.png" },
        { code: "Smiling_Emoji_with_Eyes_Opened_Icon", url: "/img/emoji/Smiling_Emoji_with_Eyes_Opened_Icon_42x42.png" },
        { code: "Smiling_Emoji_with_Smiling_Eyes_Icon", url: "/img/emoji/Smiling_Emoji_with_Smiling_Eyes_Icon_42x42.png" },
        { code: "Smiling_Face_with_Tightly_Closed_eyes_Icon", url: "/img/emoji/Smiling_Face_with_Tightly_Closed_eyes_Icon_42x42.png" },
        { code: "Smiling_with_Sweat_Emoji_Icon", url: "/img/emoji/Smiling_with_Sweat_Emoji_Icon_42x42.png" },
        { code: "Tears_of_Joy_Emoji_Icon", url: "/img/emoji/Tears_of_Joy_Emoji_Icon_42x42.png" },
        { code: "Smirk_Face_Emoji_Icon", url: "/img/emoji/Smirk_Face_Emoji_Icon_42x42.png" },
        { code: "Unamused_Face_Emoji_Icon", url: "/img/emoji/Unamused_Face_Emoji_Icon_42x42.png" },
        { code: "Sad_Face_Emoji_Icon", url: "/img/emoji/Sad_Face_Emoji_Icon_42x42.png" },
        { code: "Relieved_Emoji_Icon", url: "/img/emoji/Relieved_Emoji_Icon_42x42.png" },
        { code: "Money_Face_Emoji_Icon", url: "/img/emoji/Money_Face_Emoji_Icon_42x42.png" },
        { code: "Tongue_Out_Emoji_Icon", url: "/img/emoji/Tongue_Out_Emoji_Icon_42x42.png" },
        { code: "Tongue_Out_Emoji_with_Tightly_Closed_Eyes_Icon", url: "/img/emoji/Tongue_Out_Emoji_with_Tightly_Closed_Eyes_Icon_42x42.png" },
        { code: "Tongue_Out_Emoji_with_Winking_Eye_Icon", url: "/img/emoji/Tongue_Out_Emoji_with_Winking_Eye_Icon_42x42.png" },
        { code: "Hugging_Face_Emoji", url: "/img/emoji/Hugging_Face_Emoji_42x42.png" },
        { code: "Smiling_Face_Emoji_with_Blushed_Cheeks", url: "/img/emoji/Smiling_Face_Emoji_with_Blushed_Cheeks_42x42.png" },
        { code: "Shyly_Smiling_Face_Emoji", url: "/img/emoji/Shyly_Smiling_Face_Emoji_42x42.png" },
        { code: "Kiss_Emoji_with_Closed_Eyes", url: "/img/emoji/Kiss_Emoji_with_Closed_Eyes_42x42.png" },
        { code: "Kissing_Face_with_Smiling_Eyes_Emoji", url: "/img/emoji/Kissing_Face_with_Smiling_Eyes_Emoji_42x42.png" },
        { code: "Kissing_Face_Emoji", url: "/img/emoji/Kissing_Face_Emoji_42x42.png" },
        { code: "Nerd_with_Glasses_Emoji", url: "/img/emoji/Nerd_with_Glasses_Emoji_42x42.png" },
        { code: "Sunglasses_Emoji", url: "/img/emoji/Sunglasses_Emoji_42x42.png" },
        { code: "Grinning_Emoji_with_Smiling_Eyes", url: "/img/emoji/Grinning_Emoji_with_Smiling_Eyes_42x42.png" },
        { code: "Grinmacing_Face_Emoji", url: "/img/emoji/Grinmacing_Face_Emoji_42x42.png" },
        { code: "Hungry_Face_Emoji", url: "/img/emoji/Hungry_Face_Emoji_42x42.png" },
        { code: "Wink_Emoji", url: "/img/emoji/Wink_Emoji_42x42.png" },
        { code: "Emoji_Face_without_Mouth", url: "/img/emoji/Emoji_Face_without_Mouth_42x42.png" },
        { code: "Hushed_Face_Emoji", url: "/img/emoji/Hushed_Face_Emoji_42x42.png" },
        { code: "Frowning_Face_with_Open_Mouth_Emoji", url: "/img/emoji/Frowning_Face_with_Open_Mouth_Emoji_42x42.png" },
        { code: "Surprised_Face_Emoji", url: "/img/emoji/Surprised_Face_Emoji_42x42.png" },
        { code: "Anguished_Face_Emoji", url: "/img/emoji/Anguished_Face_Emoji_42x42.png" },
        { code: "Face_With_Rolling_Eyes_Emoji", url: "/img/emoji/Face_With_Rolling_Eyes_Emoji_42x42.png" },
        { code: "Thinking_Face_Emoji", url: "/img/emoji/Thinking_Face_Emoji_42x42.png" },
        { code: "Sleeping_with_Snoring_Emoji", url: "/img/emoji/Sleeping_with_Snoring_Emoji_42x42.png" },
        { code: "Fearful_Face_Emoji", url: "/img/emoji/Fearful_Face_Emoji_42x42.png" },
        { code: "Cold_Sweat_Emoji", url: "/img/emoji/Cold_Sweat_Emoji_42x42.png" },
        { code: "OMG_Face_Emoji", url: "/img/emoji/OMG_Face_Emoji_42x42.png" },
        { code: "Heart_Eyes_Emoji", url: "/img/emoji/Heart_Eyes_Emoji_42x42.png" },
        { code: "Blow_Kiss_Emoji", url: "/img/emoji/Blow_Kiss_Emoji_42x42.png" },
        { code: "Flushed_Face_Emoji", url: "/img/emoji/Flushed_Face_Emoji_42x42.png" },
        { code: "Smiling_Face_with_Halo", url: "/img/emoji/Smiling_Face_with_Halo_42x42.png" },
        { code: "Sleeping_Emoji", url: "/img/emoji/Sleeping_Emoji_42x42.png" },
        { code: "Expressionless_Face_Emoji", url: "/img/emoji/Expressionless_Face_Emoji_42x42.png" },
        { code: "Neutral_Face_Emoji", url: "/img/emoji/Neutral_Face_Emoji_42x42.png" },
        { code: "Very_sad_emoji_icon_png", url: "/img/emoji/Very_sad_emoji_icon_png_42x42.png" },
        { code: "Confused_Face_Emoji", url: "/img/emoji/Confused_Face_Emoji_42x42.png" },
        { code: "Worried_Face_Emoji", url: "/img/emoji/Worried_Face_Emoji_42x42.png" },
        { code: "Very_Mad_Emoji", url: "/img/emoji/Very_Mad_Emoji_42x42.png" },
        { code: "Tired_Face_Emoji", url: "/img/emoji/Tired_Face_Emoji_42x42.png" },
        { code: "Weary_Face_Emoji", url: "/img/emoji/Weary_Face_Emoji_42x42.png" },
        { code: "Persevering_Face_Emoji", url: "/img/emoji/Persevering_Face_Emoji_42x42.png" },
        { code: "Confounded_Face_Emoji", url: "/img/emoji/Confounded_Face_Emoji_42x42.png" },
        { code: "Astonished_Face_Emoji", url: "/img/emoji/Astonished_Face_Emoji_42x42.png" },
        { code: "Dizzy_Face_Emoji", url: "/img/emoji/Dizzy_Face_Emoji_42x42.png" },
        { code: "Zipper_Mouth_Face_Emoji", url: "/img/emoji/Zipper_Mouth_Face_Emoji_42x42.png" },
        { code: "Sick_Emoji", url: "/img/emoji/Sick_Emoji_42x42.png" },
        { code: "Face_With_Thermometer_Emoji", url: "/img/emoji/Face_With_Thermometer_Emoji_42x42.png" },
        { code: "Face_With_Head_Bandage_Emoji", url: "/img/emoji/Face_With_Head_Bandage_Emoji_42x42.png" },
        { code: "Very_Angry_Emoji", url: "/img/emoji/Very_Angry_Emoji_42x42.png" },
        { code: "Angry_Emoji", url: "/img/emoji/Angry_Emoji_42x42.png" },
        { code: "Disappointed_Face_Emoji", url: "/img/emoji/Disappointed_Face_Emoji_42x42.png" },
        { code: "Face_with_Cold_Sweat_Emoji", url: "/img/emoji/Face_with_Cold_Sweat_Emoji_42x42.png" },
        { code: "Loudly_Crying_Face_Emoji", url: "/img/emoji/Loudly_Crying_Face_Emoji_42x42.png" },
        { code: "Disappointed_but_Relieved_Face_Emoji", url: "/img/emoji/Disappointed_but_Relieved_Face_Emoji_42x42.png" },
        { code: "Crying_Face_Emoji", url: "/img/emoji/Crying_Face_Emoji_42x42.png" },
        { code: "Poop_Emoji", url: "/img/emoji/Poop_Emoji_42x42.png" },
        { code: "Smiling_Devil_Emoji", url: "/img/emoji/Smiling_Devil_Emoji_42x42.png" },
        { code: "Angry_Devil_Emoji_Icon", url: "/img/emoji/Angry_Devil_Emoji_Icon_42x42.png" },
        { code: "Alien_Emoji", url: "/img/emoji/Alien_Emoji_42x42.png" },
        { code: "Ghost_Emoji", url: "/img/emoji/Ghost_Emoji_42x42.png" }
    ]
};

export const EMOJI_LIST = out.EMOJI_LIST;
EMOJI_LIST._byCode = {};
EMOJI_LIST.forEach(function(emoji) {
    EMOJI_LIST._byCode[ emoji.code ] = emoji;
});
EMOJI_LIST.get = function(code) {
    return EMOJI_LIST._byCode[ code ];
};

export function html2emojiCodes(text) {
    return text.replace(out.IMG_EMOJI_REG_EXP, function(str, code) {
        return ":" + code + ":";
    });
}

export function emojiCodes2html(text) {
    return text.replace(/:(\w+):/g, function(str, code) {
        let emoji = EMOJI_LIST.get(code);
        if ( emoji ) {
            return "<img src='" + emoji.url + "' class='emoji' data-code='" + emoji.code + "'>";
        } else {
            return ":" + code + ":";
        }
    });
}

export function chatText2html(chatText) {
    // !!!!дубликат этой функции есть на бекенде!!!!
    let html = escapeHtml(chatText);
    html = emojiCodes2html(html);
    html = n2br(html);
    html = html.replace(/:\[([^\]]*) link\]\(([^)]*)\):/gi, function(str, title, href) {
        return "<a href='" + href + "'>" + title + "</a>";
    });

    return html;
}
